export default "__VITE_ASSET__v2VH4Q_w__"